let config = {
  oss: true, // 是否开启oss上传
  oss_server: '/oss_sts_server' // 是否开启oss上传
};
// 配置不同环境使用的接口地址不同
const env = process.env;
if (env.NODE_ENV === 'development') { // 本地环境
  // config.baseURL = 'http://wuxisanxing.test/api/admin';
  config.baseURL = 'https://sanxing.a2.jinyiyun.net/api/admin';
} else if (env.NODE_ENV === 'production') { // 线上环境
  config.baseURL = 'https://sanxing.a2.jinyiyun.net/api/admin';
}
// 全局配置
export {config}
